import React from 'react'
import buildInfo from 'build-info.json'
import * as Styled from './BuildInfo.styles'
import * as Component from 'components/molecules/Map/partials/Marker/Marker.styles'

/**
 * set client information
 * @returns {JSX.Element}
 * @constructor
 */
const BuildInfo = () => {
  const { revision } = buildInfo
  const buildTime = new Date(buildInfo.time)

  try {
    const { revision } = buildInfo
    const buildTime = new Date(buildInfo.time)
    localStorage.setItem('AppBuildTime', buildTime.toUTCString())
    localStorage.setItem('AppRevision', revision)
  } catch (e) {
    console.log(e)
  }

  const showRevision = false

  return (
    <>
      {showRevision && (
        <Styled.BuildInfo>
          <div className='revision-specs'>
            <div>Revision: {revision}</div>
            <div>Build Time: {buildTime.toUTCString()}</div>
          </div>
          <div className='revision-btn'>
            <Component.InfoBoxCloseIcon className='icon-f-cross' />
          </div>
        </Styled.BuildInfo>
      )}
    </>
  )
}

export default BuildInfo
